import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Store } from '@ngrx/store';
import type { Subscription } from 'rxjs';

import type { IntegrationKinds } from '@recruitee/integrations-types';

import { IntegrationEventActions } from './events/events';
import { ALL_INTEGRATION_KINDS } from './types';

@Injectable({ providedIn: 'root' })
export class InitialRouteHandlerService {
  private subscription: Subscription;

  constructor(
    private store: Store,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {}

  public init(): void {
    if (this.subscription) return;

    this.subscription = this.activatedRoute.queryParams.subscribe(params => {
      const connectedIntegrationKind: IntegrationKinds | undefined =
        params['integration_connected'];

      if (connectedIntegrationKind && ALL_INTEGRATION_KINDS.includes(connectedIntegrationKind)) {
        this.store.dispatch(
          IntegrationEventActions.AccountConnectedEvent({
            payload: { context: { integrationKind: connectedIntegrationKind } },
          }),
        );

        this.router.navigate([], {
          relativeTo: this.activatedRoute,
          queryParams: { integration_connected: null },
          queryParamsHandling: 'merge',
          replaceUrl: true,
        });
      }
    });
  }
}
